import type { MyBlogDto } from '../workspaces/dto';

// Ключи API (IAM-UC-9…12, ADR-015): удостоверение бота или агента от имени пользователя.

/**
 * Область ключа — группа действий API для интеграций. Новая область добавляется вместе с
 * маршрутами в INTEGRATION_ROUTES, подписью в интерфейсе и разделом справочника (ADR-015).
 */
export enum ApiKeyScope {
  /** Читать блог: посты, медиа (сведения), справочники, поля, статусы, каналы, план. */
  Read = 'read',
  /**
   * Загружать медиа, создавать и править посты и записи справочников; записывать выход, который
   * автор сделал сам, и исправлять запись (IAM-RULE-8).
   */
  Content = 'content',
  /** Получать пакеты публикаций с файлами и отмечать выход. */
  Publish = 'publish',
  /** Заводить и править правила оформления, справочники и поля постов (IAM-RULE-7). */
  Settings = 'settings',
}

export const API_KEY_SCOPES: readonly ApiKeyScope[] = [ApiKeyScope.Read, ApiKeyScope.Content, ApiKeyScope.Publish, ApiKeyScope.Settings];

/**
 * Что отмечено при выпуске: боту приёма материалов нужны чтение и контент, публикация — по
 * выбору. Настройки — тоже по выбору: правка полей стирает значения во всём блоге (IAM-RULE-7).
 */
export const API_KEY_DEFAULT_SCOPES: readonly ApiKeyScope[] = [ApiKeyScope.Read, ApiKeyScope.Content];

export function isApiKeyScope(value: unknown): value is ApiKeyScope {
  return API_KEY_SCOPES.includes(value as ApiKeyScope);
}

/** Начало каждого ключа: отличает его от токена сессии и помогает сканерам секретов. */
export const API_KEY_PREFIX = 'grk_';

export function isApiKeySecret(token: string): boolean {
  return token.startsWith(API_KEY_PREFIX);
}

export const API_KEY_NAME_MAX_LENGTH = 100;

export interface ApiKeyOwnerDto {
  id: string;
  login: string;
  displayName: string;
}

// IAM-UC-10, IAM-UC-11: ключ без секрета — его видно только при выпуске (IAM-RULE-4).
export interface ApiKeyDto {
  id: string;
  name: string;
  /** Начало ключа: grk_ и 8 символов. */
  prefix: string;
  scopes: ApiKeyScope[];
  owner: ApiKeyOwnerDto;
  createdAt: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
}

// IAM-UC-9
export interface IssueApiKeyRequestDto {
  name: string;
  scopes: ApiKeyScope[];
}

// IAM-UC-11
export interface AdminIssueApiKeyRequestDto extends IssueApiKeyRequestDto {
  userId: string;
}

/** Ответ выпуска: секрет показывается один раз (IAM-RULE-4). */
export interface IssuedApiKeyDto {
  key: ApiKeyDto;
  secret: string;
}

export interface AdminApiKeysQuery {
  userId?: string;
}

// IAM-UC-12: проверка ключа внешним клиентом.
export interface IntegrationMeDto {
  user: ApiKeyOwnerDto;
  /** Ключ запроса; null — запрос пришёл с сессией интерфейса. */
  key: { id: string; name: string; prefix: string; scopes: ApiKeyScope[] } | null;
  blogs: MyBlogDto[];
}
